import React, { useState, useEffect } from "react";

/// Components
import Markup from './markup/Markup';
import PremiumLoader from './markup/Element/PremiumLoader';

/// Style
import "./vendor/bootstrap-select/bootstrap-select.min.css";
import "./vendor/animate/animate.css";
import "./css/style.css";
import "./css/header-dropdown.css";
import './vendor/slick/slick.min.css';
import './vendor/slick/slick-theme.min.css';
import 'react-modal-video/css/modal-video.min.css';

import { withResizeDetector } from "react-resize-detector";

const MIN_LOADER_TIME = 1200;

function App() {
	const [loading, setLoading] = useState(true);
	const [hiding, setHiding] = useState(false);

	useEffect(() => {
		const hideLoader = () => {
			setHiding(true);
			setTimeout(() => {
				setLoading(false);
			}, 600);
		};

		const onLoad = () => {
			setTimeout(hideLoader, MIN_LOADER_TIME);
		};

		if (document.readyState === 'complete') {
			onLoad();
		} else {
			window.addEventListener('load', onLoad);
			return () => window.removeEventListener('load', onLoad);
		}
	}, []);

	return (
		<div className="App">
			<PremiumLoader visible={loading} hiding={hiding} />
			<Markup />
		</div>
	);
}

export default withResizeDetector(App);
